/// <reference path="references/jquery.d.ts" />
interface Window { zdivnit: any; }

class Star{
  constructor(
      public x:number,
      public y:number,
      public size:number,
      public speed:number,
      public shadowBlur:number,
      public shadowColor:string,
      public fillStyle:string)
  {}
}

var countFPS = (function () {
  var lastLoop = (new Date()).getMilliseconds();
  var count = 1;
  var fps = 0;

  return function () {
    var currentLoop = (new Date()).getMilliseconds();
    if (lastLoop > currentLoop) {
      fps = count;
      count = 1;
    } else {
      count++;
    }
    lastLoop = currentLoop;
    return fps;
  };
}());
class Sky{
  $el: JQuery;
  c: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  stars: Array<Star> = [];
  angle: number = 360;
  thing: number = 0;

  constructor($elem: JQuery){
    // console.log("construct");
    this.$el = $elem;
    this.c = <HTMLCanvasElement> $elem.get(0);
    this.ctx = this.c.getContext("2d");
    this.buildStars();

    window.requestAnimationFrame(this.draw.bind(this));
    window.onresize = this.buildStars.bind(this);
  }

  private buildStars(){
    // console.log("build stars");
    this.stars = [];
    var xMax = this.c.width = this.$el.parent().width();
    var yMax = this.c.height = this.$el.parent().height();
    var hmTimes = Math.round((xMax + yMax)*0.6);

    for (let i = 0; i <= hmTimes; i++) {
      let random = {
        "x": Math.floor((Math.random() * xMax) + 1),
        "y": Math.floor((Math.random() * yMax*2) + 1),
        "size": Math.floor((Math.random() * 2) + 1),
        "opacity1": Math.floor((Math.random() * 9) + 1),
        "opacity2": Math.floor((Math.random() * 9) + 1),
        "hue": Math.floor((Math.random() * 360) + 1),
        "rand": Math.random()
      };
      if(random.rand > 0.5){ random.rand = 0.5 }
      else if(random.rand < 0.1){ random.rand = 0.1 }
      let randomSpeed = Math.floor((random.rand +0.1) * 10 )/10;

      if (random.size > 1) {
        var shadowBlur = Math.floor((Math.random() * 15) + 5);
        var shadowColor = "white";
      }else{
        var shadowBlur = 0;
        var shadowColor = "";
      }
      let fillStyle = "hsla(" + random.hue + ", 30%, 80%, ." + random.opacity1 + random.opacity2 + ")";

      this.stars.push(new Star(random.x, random.y, random.size, randomSpeed, shadowBlur, shadowColor, fillStyle));
    }
  }

  draw() {
    // console.log("draw");
    if(!window.zdivnit){
      this.ctx.clearRect(0, 0, this.c.width, this.c.height);
    }

    // x^2 + y^2 = r^2
    // this.ctx.beginPath();
    for (let star of this.stars) {
      if (star.size > 1) {
        this.ctx.shadowBlur = star.shadowBlur;
        this.ctx.shadowColor = star.shadowColor;
      }
      this.ctx.fillStyle = star.fillStyle;
      if(star.x < 0){
        star.x = this.c.width;
      }
      star.x -= star.speed;

      let circleX = Math.abs(this.c.width/2 - star.x);
      let circleY = Math.sqrt(Math.pow(this.c.height*2.5,2) - Math.pow(circleX,2));
      let y = star.y - (circleY - this.c.height*2);
      if(y > 0 && y < this.c.height){
      //  rendering only stars that are actually visible on canvas
        this.ctx.fillRect(star.x, y, star.size, star.size);
      }
    }
     // SHOW FPS
    // this.ctx.shadowBlur = 0;
    // this.ctx.fillStyle = "white";
    // this.ctx.font = "bold 24px Arial";
    // this.ctx.textAlign = "left";
    // this.ctx.fillText("FPS: "+countFPS(), 50, this.c.height - 50);

  //  SHOW GUIDELINE PATH
  //   this.ctx.shadowBlur = 40;
  //   this.ctx.beginPath();
  //   this.ctx.arc(this.c.width/2,this.c.height*3,this.c.height*2.5,0,2*Math.PI);
  //   this.ctx.stroke();

    var self = this;
    setTimeout(function(){
      window.requestAnimationFrame(self.draw.bind(self));
    },1000/20)
  }

}

